export default "__VITE_ASSET__5364b0de__"